// import React, { createContext, useContext, useState, useEffect } from "react";

// const CartContext = createContext();

// export function CartProvider({ children }) {
//   const [cartItems, setCartItems] = useState(() => {
//     const stored = localStorage.getItem("cart");
//     return stored ? JSON.parse(stored) : [];
//   });

//   useEffect(() => {
//     localStorage.setItem("cart", JSON.stringify(cartItems));
//   }, [cartItems]);

//   const addToCart = (product) => {
//     setCartItems((prev) => {
//       const existing = prev.find((item) => item.id === product.id);
//       if (existing) {
//         if (existing.quantity >= existing.quantite) return prev;
//         return prev.map((item) =>
//           item.id === product.id
//             ? { ...item, quantity: item.quantity + 1 }
//             : item
//         );
//       }
//       return [...prev, { ...product, quantity: 1 }];
//     });
//   };

//   const removeFromCart = (productId) => {
//     setCartItems((prev) => prev.filter((item) => item.id !== productId));
//   };

//   const increaseQuantity = (productId) => {
//     setCartItems((prev) =>
//       prev.map((item) =>
//         item.id === productId && item.quantity < item.quantite
//           ? { ...item, quantity: item.quantity + 1 }
//           : item
//       )
//     );
//   };

//   const decreaseQuantity = (productId) => {
//     setCartItems((prev) =>
//       prev.map((item) =>
//         item.id === productId && item.quantity > 1
//           ? { ...item, quantity: item.quantity - 1 }
//           : item
//       )
//     );
//   };

//   const clearCart = () => {
//     if (window.confirm("Voulez-vous vraiment vider le panier ?")) {
//       setCartItems([]);
//       localStorage.removeItem("cart");
//     }
//   };

//   const clearCartAfterSending = () => {
//     setCartItems([]);
//     localStorage.removeItem("cart");
//   };

//   const totalItems = cartItems.reduce((acc, item) => acc + item.quantity, 0);
//   const totalProduits = cartItems.length;
//   const totalPrice = cartItems.reduce(
//     (acc, item) => acc + (item.prix_promo ?? item.prix) * item.quantity,
//     0
//   );

//   return (
//     <CartContext.Provider
//       value={{
//         cartItems,
//         addToCart,
//         removeFromCart,
//         increaseQuantity,
//         decreaseQuantity,
//         clearCart,
//         clearCartAfterSending,
//         totalItems,
//         totalProduits,
//         totalPrice,
//       }}
//     >
//       {children}
//     </CartContext.Provider>
//   );
// }

// export const useCart = () => useContext(CartContext);

// AsNumeric

import React, { createContext, useContext, useState, useEffect } from "react";

const CartContext = createContext();

export function CartProvider({ children }) {
  const [cartItems, setCartItems] = useState(() => {
    const stored = localStorage.getItem("cart");
    return stored ? JSON.parse(stored) : [];
  });

  useEffect(() => {
    localStorage.setItem("cart", JSON.stringify(cartItems));
  }, [cartItems]);

  const addToCart = (product) => {
    const productId = product.product_id;
    const prix =
      product.product_variations?.[0]?.variations?.[0]
        ?.default_purchase_price || product.variations?.[0]?.purchase_price;

    setCartItems((prev) => {
      const existing = prev.find((item) => item.product_id === productId);

      if (existing) {
        return prev.map((item) =>
          item.product_id === productId
            ? { ...item, quantity: item.quantity + 1 }
            : item
        );
      }

      return [
        ...prev,
        {
          product_id: productId,
          name: product.name,
          sku: product.sku,
          image_url: product.image_url,
          price: prix || 0,
          quantity: 1,
        },
      ];
    });
  };

  const removeFromCart = (product_id) => {
    setCartItems((prev) =>
      prev.filter((item) => item.product_id !== product_id)
    );
  };

  const increaseQuantity = (product_id) => {
    setCartItems((prev) =>
      prev.map((item) =>
        item.product_id === product_id
          ? { ...item, quantity: item.quantity + 1 }
          : item
      )
    );
  };

  const decreaseQuantity = (product_id) => {
    setCartItems((prev) =>
      prev.map((item) =>
        item.product_id === product_id && item.quantity > 1
          ? { ...item, quantity: item.quantity - 1 }
          : item
      )
    );
  };

  const clearCart = () => {
    if (window.confirm("Voulez-vous vraiment vider le panier ?")) {
      setCartItems([]);
      localStorage.removeItem("cart");
      window.scrollTo({ top: 0, behavior: "auto" });
    }
  };

  const clearCartAfterSending = () => {
    setCartItems([]);
    localStorage.removeItem("cart");
    window.scrollTo({ top: 0, behavior: "auto" });
  };

  const totalItems = cartItems.reduce((acc, item) => acc + item.quantity, 0);
  const totalProduits = cartItems.length;
  const totalPrice = cartItems.reduce(
    (acc, item) => acc + item.price * item.quantity,
    0
  );

  return (
    <CartContext.Provider
      value={{
        cartItems,
        addToCart,
        removeFromCart,
        increaseQuantity,
        decreaseQuantity,
        clearCart,
        clearCartAfterSending,
        totalItems,
        totalProduits,
        totalPrice,
      }}
    >
      {children}
    </CartContext.Provider>
  );
}

export const useCart = () => useContext(CartContext);
